import script from "./NormalRegisterView.vue?vue&type=script&setup=true&lang=js"
export * from "./NormalRegisterView.vue?vue&type=script&setup=true&lang=js"

import "./NormalRegisterView.vue?vue&type=style&index=0&id=2771f494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2771f494"]])

export default __exports__